module.exports = __webpack_public_path__ + "fonts/Artifakt-Element-Black.d807dc0d.woff";